import React from "react"
import priceSymbolSrc from "assets/images/icons/product_detail_price_symbol.png"

/**
 * Same SAR symbol asset as website-template ProductCard / MoneyValue.
 */
const PriceSymbol = ({ className = "", size = 16 }) => (
  <img
    src={priceSymbolSrc}
    alt=""
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    draggable={false}
  />
)

export default PriceSymbol
